import { EstablishmentMapAction } from "../types/action";

export const endpointFiltersForActions = (action?: EstablishmentMapAction) => {
  if (action?.name === 'price_search') {
    return {
      'q[product_price_product_id_eq]': action?.properties?.product_id || undefined,
    };
  }

  return {};
};
